import { CompanyTable } from "@/pages/company-list/ui/company-table";
import { SearchForm } from "@/pages/company-list/ui/search-form";
import { ScrollToTop } from "@/shared/lib/ScrollToTop";
import { BaseButton } from "@/shared/ui/BaseButton";
import { BaseIcon } from "@/shared/ui/BaseIcons";
import { BasePagination } from "@/shared/ui/base-pagination";
import { BasePaginationControl } from "@/shared/ui/base-pagination-control";
import { Box, Collapse, Stack, Typography } from "@mui/material";
import { useState } from "react";
import type { CompanyListPageProps } from "../model";

type Props = CompanyListPageProps;

export const CompanyListPageUi = ({
  companies,
  pagination,
  onSearch,
}: Props) => {
  const [showFilters, setShowFilters] = useState(false);

  const [filterCount, setFilterCount] = useState(0);

  return (
    <Stack px={{ xs: 2, sm: 4 }} pb={2} spacing={{ xs: 2, sm: 4 }}>
      {/* ヘッダー */}
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <ScrollToTop />
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          会社管理
        </Typography>
      </Stack>

      {/* フィルター */}
      <Stack spacing={4}>
        <Box display="flex" justifyContent="space-between">
          <BaseButton
            sx={{
              paddingLeft: {
                xs: 2,
                sm: 1,
              },
              paddingRight: {
                xs: 1,
                sm: 1,
              },
              borderColor: "grey.300",
              color: "grey.700",
            }}
            variant="outlined"
            startIcon={<BaseIcon name="filter" />}
            onClick={() => {
              setShowFilters((current) => !current);
            }}
          >
            <Typography fontWeight={700} mr={1}>
              フィルター
            </Typography>
            <Box
              width={"24px"}
              height={"24px"}
              display="flex"
              justifyContent="center"
              alignItems="center"
              p={0}
              borderRadius="50%"
              bgcolor="primary.500"
              color="white"
            >
              <Typography>{filterCount}</Typography>
            </Box>
          </BaseButton>
        </Box>

        {/* 検索フォーム */}
        <Collapse
          in={showFilters}
          sx={{
            display: { xs: "none", sm: "block" },
            visibility: { xs: "hidden", sm: "visible" },
          }}
        >
          <SearchForm onSearch={onSearch} setFilterCount={setFilterCount} />
        </Collapse>

        {/* 会社一覧テーブル */}
        <Stack
          direction="column"
          spacing={2}
          // display={{ xs: "none", sm: "block" }}
        >
          {pagination && (
            <BasePaginationControl
              page={pagination.page}
              perPage={pagination.perPage}
              totalCount={pagination.totalCount}
              onPerPageChange={pagination.onPerPageChange}
            />
          )}

          {companies.status === "success" && (
            <CompanyTable companies={companies.data.companies} />
          )}

          {pagination && (
            <BasePagination
              page={pagination.page}
              perPage={pagination.perPage}
              totalCount={pagination.totalCount}
              onPageChange={pagination.onPageChange}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
